import { configureStore } from '@reduxjs/toolkit';

import { breedModel } from 'entities/breed';
import { countryModel } from 'entities/country';
import { diseaseModel, diseasePetsModel } from 'entities/disease';
import { pharmaceuticalCompanyModel } from 'entities/pharmaceutical-company';
import { supportMessageModel } from 'entities/support-message';
import { translationModel } from 'entities/translation';
import { userModel } from 'entities/user';
import { vaccineModel, vaccinePetsModel } from 'entities/vaccine';
import { voiceModel } from 'entities/voice';

export const store = configureStore({
  reducer: {
    user: userModel.reducer,
    countries: countryModel.reducer,
    diseases: diseaseModel.reducer,
    vaccines: vaccineModel.reducer,
    vaccinesPets: vaccinePetsModel.reducerPets,
    diseasePets: diseasePetsModel.reducerPets,
    breeds: breedModel.reducer,
    voices: voiceModel.reducer,
    supportMessages: supportMessageModel.reducer,
    pharmaCompanies: pharmaceuticalCompanyModel.reducer,
    translations: translationModel.reducer,
  },
});
